import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'
import { colorBrandPrimary } from '../../../../global.style'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${colorBrandPrimary.turquoise};
  height: fit-content;
  padding: 20px 0;
`

export const Container = styled.div`
  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
  display: flex;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
`

export const TextWrap = styled.div`
  padding: 20px;
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
    max-width: 100%;
  `}
  ${media.phone`
    text-align: left;
    line-height: 36px;
  `}
  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 300px;
  line-height: 40px;
  padding-bottom: 10px;
`

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  color: ${(props) => props.color};
  padding: 0;
  text-align: left;
  max-width: 415px;
`

export const Image = styled.img`
  ${media.desktop`
    text-align: left;
    width: 90%;
    height: 100%;
  `}
  max-width: 430px;
`